import request from "../utlis/request"

//客服二维码
export function getQrCode(param){
  return request({
    url: '/count/getQrCode?ccid=' + param,
    method: 'get',
    urltype: 'vip2022',
  })
}

//免费试用
export function openTryCard(){
  return request({
    url: '/openTryCard',
    method: 'get',
    urltype: 'vip2022',
  })
}

//开通3个月会员
export function openCountCard(param){
  return request({
    url: '/count/openCountCard?ggid=' + param,
    method: 'get',
    urltype: 'vip2022',
  })
}

//是否领取3个月会员按钮显示
export function isShowButton(param){
  return request({
    url: '/count/isShowButton',
    method: 'post',
    data: param,
    urltype: 'vip2022',
  })
}

//创建销售人员方法
export function createPerson(){
  return request({
    url: '/count/createPerson',
    method: 'get',
    urltype: 'vip2022',
  })
}

//是否为营销人员
export function IsPerson(){
  return request({
    url: '/count/IsPerson',
    method: 'get',
    urltype: 'vip2022',
  })
}

//获取邀请码
export function getCode(param){
  return request({
    url: '/getCode'+ (param != null?('?tcode=' + param) : ''),
    method: 'get',
    urltype: 'vip2022',
  })
}

//会员列表
export function getCardList(){
  return request({
    url: '/getCardList',
    method: 'get',
    urltype: 'vip2022',
  })
}

//确定加入会员
export function createOrder(param){
  return request({
    url: '/createOrder?goodsId=' + param,
    method: 'get',
    urltype: 'vip2022',
  })
}

//微信分享
export function getJsSdkConfig(param){
  return request({
    //url: '/getJsSdkConfig',
    url: '/share',
    method: 'post',
    data: param,
    urltype: 'share',
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js